<script setup lang="ts">
type Props = {
  name?: string;
  hideIcon?: boolean;
};

const { name = 'curp', hideIcon } = defineProps<Props>();

const modelValue = defineModel<string>('modelValue', {
  default: '',
});

const isDocumentValid = ref<boolean>(false);
const userDocumentError = ref<string>('');

const isIconVisible = computed<boolean>(() => {
  return !hideIcon;
});

watch(userDocumentError, () => {
  if (!userDocumentError.value) {
    return;
  }

  setTimeout(() => {
    userDocumentError.value = '';
  }, 5000);
});
</script>

<template>
  <div :class="$style.inputCurp">
    <BaseFormInput
      id="document"
      v-model="modelValue"
      :class="[$style.input, { error: userDocumentError }]"
      v-bind="$attrs"
      :disabled="isDocumentValid"
      :maxlength="18"
      :minlength="10"
      :name="name"
      type="text"
    >
      <template #prepend>
        <div
          v-if="isIconVisible"
          :class="$style.icon"
        >
          <NuxtIcon
            v-if="modelValue && isDocumentValid"
            class="text-success"
            name="check"
          />
          <NuxtIcon
            v-else
            name="file"
          />
        </div>
      </template>
    </BaseFormInput>

    <div
      v-if="userDocumentError"
      :class="$style.errorMessage"
    >
      {{ userDocumentError }}
    </div>
  </div>
</template>

<style module lang="postcss">
.inputCurp {
  @apply relative flex items-center;
}

.input {
  @apply w-full;

  &.small {
    @apply h-[40px] text-sm text-left pl-[40px];
  }

  &[disabled]:not([disabled='false']) {
    @apply opacity-40 cursor-not-allowed;
  }

  &[readonly]:not([readonly='false']) {
    @apply cursor-default opacity-90;
  }
}

.icon {
  @apply w-9 h-9 text-sm text-auth-text-inputs/60 z-10 flex justify-center items-center;
}

.errorMessage {
  @apply absolute bottom-0 right-0 rounded-sm rounded-br;
  @apply text-center text-[.5rem] pr-1 pl-1.5 pt-1 pb-0.5 bg-error text-texts;
}
</style>
